
    import { defineComponent } from 'vue';
    import XBreadcrumb from '@/apps/shared/components/breadcrumb.vue';
    import webSaleHelper from '@/apps/shared/utils/webSaleHelper';

    export default defineComponent({
        name: 'travelAssistance-tab-two',
        components: {
            XBreadcrumb,
        },
        data() {
            // La salida se permite recién desde mañana (hoy + 1); medianoche para que el
            // datepicker habilite ese día completo sin depender de la hora actual.
            const departureDateMin = new Date();
            departureDateMin.setDate(departureDateMin.getDate() + 1);
            departureDateMin.setHours(0, 0, 0, 0);

            return {
                breadcrumItems: [
                    { text: 'Inicio', path: '/asistencia-viajero' },
                    { text: 'Datos del Viaje', path: '/asistencia-viajero/datos-viaje' },
                ],
                // Selecciones hechas en las pantallas de cards previas (destino / tipo de viaje)
                selectedDestination: null,
                selectedTripType: null,
                // Evita que el watcher de departureDate recalcule la fecha de regreso
                // mientras se restauran los datos guardados al volver de planes
                isRestoringData: false,
                // Fechas
                departureDate: new Date(),
                departureDateMin: departureDateMin,
                returnDate: new Date(),
                returnDateMin: new Date(),
                returnDateKey: new Date().getTime(),
                format: 'DD/MM/YYYY',
                messageErrorDate: null,
                // Pasajeros
                passengersUnder21: 0,
                passengersBetween21And75: 0,
                passengersOver75: 0,
                passengersTotalMax: 9,
                passengerGroups: [
                    { key: 'passengersUnder21', label: 'Menores a 21 años' },
                    { key: 'passengersBetween21And75', label: 'Entre 21 y 75 años' },
                    { key: 'passengersOver75', label: 'Mayores a 75 años' },
                ],
                messageErrorPassengers: null,
                // Cuotas (mock)
                allInstallmentOptions: [
                    { id: 1, description: '1 cuota' },
                    { id: 3, description: '3 cuotas' },
                    { id: 6, description: '6 cuotas' },
                    { id: 12, description: '12 cuotas' },
                ],
                selectedInstallment: null,
                // Autocomplete config (misma config usada en otros productos)
                autocompleteConfig: {
                    formatResult: function (item: any) {
                        return item.description;
                    },
                    selection: function (item: any) {
                        return item.description;
                    },
                },
                referente: null,
            }
        },
        computed: {
            // El id llega numérico desde el backend; se normaliza para no depender del tipo
            isSingleTrip(): boolean {
                return this.selectedTripType != null && String(this.selectedTripType.id) === '1';
            },

            isReturnDateDisabled(): boolean {
                return this.selectedTripType != null && !this.isSingleTrip;
            },

            returnDateMax(): Date | null {
                if (!this.isSingleTrip || this.departureDate == null) {
                    return null;
                }
                const max = new Date(this.departureDate);
                max.setDate(max.getDate() + 365);
                return max;
            },
            departureDateMax(): Date {
                const max = new Date();
                max.setDate(max.getDate() + 365);
                return max;
            },
            totalPassengers(): number {
                return (Number(this.passengersUnder21) || 0)
                    + (Number(this.passengersBetween21And75) || 0)
                    + (Number(this.passengersOver75) || 0);
            },

            installmentOptions(): any[] {
                if (this.isSingleTrip) {
                    return this.allInstallmentOptions.filter((o: any) => o.id === 1);
                }
                return this.allInstallmentOptions;
            },
        },
        methods: {
            async pageCustomization() {
                const defaultTitle = 'Asistencia al Viajero';
                const actualPath = '/asistencia-viajero';
                try {
                    await webSaleHelper.pageCustomization(this.$route, this.Bus, this.$store, defaultTitle, actualPath, null, null);
                }
                catch (error) {
                    const statusCode = error.response?.status;
                    this.Bus.$emit(
                        'show-service-fail',
                        statusCode,
                        [() => this.pageCustomization()]);
                }
            },

            updateByProductGoogleAnalytics() {
                window.globalThis.dataLayer = window.globalThis.dataLayer || [];
                const productGtmName = 'DefaultTravelAssistanceGTMInfo';
                this.Bus.$emit('updateByProductGoogleAnalytics', productGtmName);
            },

            addPassenger(category: string) {
                if (this.totalPassengers >= this.passengersTotalMax) return;
                this.$data[category] = (Number(this.$data[category]) || 0) + 1;
            },

            restPassenger(category: string) {
                const current = Number(this.$data[category]) || 0;
                if (current > 0) this.$data[category] = current - 1;
            },

            clampPassengerGroup(category: string, newVal: any) {
                let value = Number(newVal);
                if (isNaN(value) || value < 0) value = 0;
                value = Math.floor(value);
                const others = this.totalPassengers - (Number(this.$data[category]) || 0);
                const maxAllowed = this.passengersTotalMax - others;
                if (value > maxAllowed) value = maxAllowed;
                if (this.$data[category] !== value) this.$data[category] = value;
            },

            cotizar() {
                this.messageErrorDate = null;
                this.messageErrorPassengers = null;
                var validDepartureDate = this.departureDate != null;
                var validReturnDate = this.returnDate != null;
                var validInstallment = this.selectedInstallment != null;

                // La salida debe ser desde mañana (el datepicker lo limita, pero la fecha
                // también puede tipearse a mano)
                if (validDepartureDate) {
                    var departureDay = new Date(this.departureDate);
                    departureDay.setHours(0, 0, 0, 0);
                    if (departureDay < this.departureDateMin) {
                        this.messageErrorDate = 'La fecha de salida debe ser a partir de mañana.';
                        return;
                    }
                }

                // Validar que la fecha de regreso sea posterior a la de salida
                if (validDepartureDate && validReturnDate) {
                    var departure = new Date(this.departureDate);
                    var returnD = new Date(this.returnDate);
                    if (returnD <= departure) {
                        this.messageErrorDate = 'La fecha de regreso debe ser posterior a la fecha de salida.';
                        return;
                    }
                }

                if (this.totalPassengers < 1) {
                    this.messageErrorPassengers = 'Debés indicar al menos 1 pasajero.';
                    return;
                }

                if (this.totalPassengers > this.passengersTotalMax) {
                    this.messageErrorPassengers = `El total de pasajeros no puede superar ${this.passengersTotalMax}.`;
                    return;
                }

                if (validDepartureDate && validReturnDate && validInstallment) {
                    NF.UI.Page.block();
                    // Guardar datos del viaje en sessionStorage
                    const travelData = {
                        destination: this.selectedDestination,
                        tripType: this.selectedTripType,
                        departureDate: this.departureDate,
                        returnDate: this.returnDate,
                        installment: this.selectedInstallment,
                        passengersUnder21: this.passengersUnder21,
                        passengersBetween21And75: this.passengersBetween21And75,
                        passengersOver75: this.passengersOver75,
                        passengersCount: this.totalPassengers,
                    };
                    sessionStorage.setItem("TravelDetailsData", JSON.stringify(travelData));

                    this.$router.push({
                        name: 'travelAssistance-tab-three',
                    });

                    NF.UI.Page.unblock();
                }
            },

            volver() {
                NF.UI.Page.block();
                sessionStorage.setItem("pressBack", "true");
                this.$router.push({
                    name: 'travelAssistance-trip-type',
                });
            },

            // Deriva fechas y cuota a partir del tipo de viaje seleccionado en la pantalla de cards.
            // Salida por defecto: mañana; regreso: salida +1 día (viaje único) o +365 (anual).
            applyTripTypeDefaults() {
                var departureRef = new Date();
                departureRef.setDate(departureRef.getDate() + 1);
                this.departureDate = departureRef;
                var returnRef = new Date(departureRef);
                if (this.isSingleTrip) {
                    returnRef.setDate(returnRef.getDate() + 1);
                } else {
                    returnRef.setDate(returnRef.getDate() + 365);
                }
                this.returnDate = returnRef;
                this.returnDateKey = new Date().getTime();

                // Viaje unico -> 1 cuota autoseleccionada
                if (this.isSingleTrip) {
                    this.selectedInstallment = this.allInstallmentOptions.find((o: any) => o.id === 1) || null;
                }
            },

            getInitData() {
                sessionStorage.setItem("ExitOrContinueModal", "true");
                window.globalThis.dataLayer = window.globalThis.dataLayer || [];

                var referente = sessionStorage.getItem("Referente");
                referente == 'null' || referente == null ? this.referente = null : this.referente = referente;

                // Selecciones hechas en las pantallas de cards previas
                var destinationRaw = JSON.parse(sessionStorage.getItem("TravelDestinationSelected"));
                var tripTypeRaw = JSON.parse(sessionStorage.getItem("TravelTripTypeSelected"));
                if (destinationRaw == null || tripTypeRaw == null) {
                    // Guard: entrada directa por URL sin selección previa
                    this.$router.push({ name: 'travelAssistance-destination' });
                    return;
                }
                this.selectedDestination = { id: destinationRaw.code, description: destinationRaw.productDescription };
                this.selectedTripType = { id: tripTypeRaw.code, description: tripTypeRaw.productDescription };

                var validBack = sessionStorage.getItem("pressBackFromPlans");
                var travelDataJson = null;
                if (validBack) {
                    sessionStorage.removeItem("pressBackFromPlans");
                    var travelData = sessionStorage.getItem("TravelDetailsData");
                    if (travelData != null) {
                        travelDataJson = JSON.parse(travelData);
                    }
                }

                if (travelDataJson != null && String(travelDataJson.tripType?.id) === String(this.selectedTripType.id)) {
                    // Vuelve de planes sin cambiar el tipo de viaje: restaurar todo tal como estaba
                    this.isRestoringData = true;
                    this.departureDate = travelDataJson.departureDate;
                    this.returnDate = travelDataJson.returnDate;
                    var nextDay = new Date(travelDataJson.departureDate);
                    nextDay.setDate(nextDay.getDate() + 1);
                    this.returnDateMin = nextDay;
                    this.selectedInstallment = travelDataJson.installment ?? null;
                    this.passengersUnder21 = travelDataJson.passengersUnder21 ?? 0;
                    this.passengersBetween21And75 = travelDataJson.passengersBetween21And75 ?? 0;
                    this.passengersOver75 = travelDataJson.passengersOver75 ?? 0;
                    this.returnDateKey = new Date().getTime();
                    // El flush de watchers de Vue corre antes que este callback
                    this.$nextTick(() => { this.isRestoringData = false; });
                } else {
                    // Primera entrada, o volvió atrás y cambió el tipo de viaje: re-derivar fechas/cuota
                    this.applyTripTypeDefaults();
                    if (travelDataJson != null) {
                        // Los pasajeros no dependen del tipo de viaje, se conservan
                        this.passengersUnder21 = travelDataJson.passengersUnder21 ?? 0;
                        this.passengersBetween21And75 = travelDataJson.passengersBetween21And75 ?? 0;
                        this.passengersOver75 = travelDataJson.passengersOver75 ?? 0;
                    }
                }

                var dataTabHome = JSON.parse(sessionStorage.getItem("DataTabHome"));
                window.globalThis.dataLayer.push({
                    'pas': null,
                    'email': dataTabHome ? dataTabHome.email : null,
                    'referente': this.referente,
                    'product': 'asistencia-viaje',
                    'event': 'cotizador-asistencia-viaje-datos-viaje'
                });
                window.globalThis._qsie = window.globalThis._qsie || [];
                window.globalThis._qsie.push('cotizador-asistencia-viaje-datos-viaje');
            },
        },
        watch: {
            passengersUnder21(newVal) {
                this.clampPassengerGroup('passengersUnder21', newVal);
                if (this.totalPassengers >= 1) this.messageErrorPassengers = null;
            },
            passengersBetween21And75(newVal) {
                this.clampPassengerGroup('passengersBetween21And75', newVal);
                if (this.totalPassengers >= 1) this.messageErrorPassengers = null;
            },
            passengersOver75(newVal) {
                this.clampPassengerGroup('passengersOver75', newVal);
                if (this.totalPassengers >= 1) this.messageErrorPassengers = null;
            },
            departureDate(newVal) {
                if (newVal == null) return;
                // No recalcular mientras se restauran los datos guardados (el flush del
                // watcher es asíncrono y pisaría la fecha de regreso restaurada)
                if (this.isRestoringData) return;

                this.messageErrorDate = null;

                // El mínimo de regreso es el día siguiente a la salida
                const nextDay = new Date(newVal);
                nextDay.setDate(nextDay.getDate() + 1);
                this.returnDateMin = nextDay;

                // Recalcular returnDate según el tipo de viaje (o ajustar si quedó inválida)
                if (this.isSingleTrip) {
                    this.returnDate = nextDay;
                } else if (this.selectedTripType) {
                    const oneYearLater = new Date(newVal);
                    oneYearLater.setDate(oneYearLater.getDate() + 365);
                    this.returnDate = oneYearLater;
                } else if (this.returnDate != null && new Date(this.returnDate) <= new Date(newVal)) {
                    // Sin tipo de viaje seleccionado aún, solo ajustamos si quedó inválida
                    this.returnDate = nextDay;
                }

                this.returnDateKey = new Date().getTime();
            },
        },


        async mounted() {
            try {
                NF.UI.Page.block();
                await this.pageCustomization();
                await this.updateByProductGoogleAnalytics();
                await this.getInitData();
            } finally {
                NF.UI.Page.unblock();
            }
        },
    })
